// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"d119cb11","419":"fea7c212","453":"7e4d5424"}[chunkId] + ".chunk.js";
};